export default __webpack_public_path__ + "static/media/notification.275eaeb5.wav";